import React from 'react';
import { FileText, ShoppingBag, Truck, CreditCard, RotateCcw, AlertTriangle, Scale, HelpCircle } from 'lucide-react';

const TermsConditionsPage = () => {

  const sections = [
    {
      icon: ShoppingBag,
      title: 'Ordini e Acquisti',
      content: `Effettuando un ordine su QANTRI, accetti le seguenti condizioni:
        • L'ordine costituisce una proposta di acquisto vincolante
        • La conferma dell'ordine via email rappresenta l'accettazione del contratto
        • I prezzi sono espressi in Euro (€) e includono IVA
        • Ci riserviamo il diritto di rifiutare ordini in caso di errori evidenti nei prezzi
        • La disponibilità dei prodotti è soggetta a verifica al momento dell'ordine
        • Gli ordini possono essere annullati solo prima della spedizione`
    },
    {
      icon: CreditCard,
      title: 'Pagamenti',
      content: `Metodi di pagamento accettati e relative condizioni:
        • PayPal: Pagamento sicuro tramite il tuo conto PayPal o carta di credito/debito
        • Il pagamento viene addebitato al momento della conferma dell'ordine
        • In caso di pagamento non andato a buon fine, l'ordine verrà annullato
        • Non accettiamo pagamenti in contrassegno
        • Per ordini B2B con fattura, il pagamento è sempre anticipato`
    },
    {
      icon: Truck,
      title: 'Spedizioni e Consegne',
      content: `Informazioni sulle nostre politiche di spedizione:
        • Spedizione GRATUITA per ordini superiori a €50
        • Costo spedizione standard: €4,99 per ordini inferiori a €50
        • Tempi di consegna: 7-15 giorni lavorativi (prodotti internazionali)
        • Spediamo in tutta Italia e nei principali paesi europei
        • Il tracking viene inviato via email non appena disponibile
        • Non siamo responsabili per ritardi dovuti a dogana o corriere
        • In caso di mancata consegna, contattare l'assistenza entro 30 giorni`
    },
    {
      icon: RotateCcw,
      title: 'Resi e Rimborsi',
      content: `Diritto di recesso e politica resi:
        • Hai 14 giorni dalla ricezione per esercitare il diritto di recesso
        • I prodotti devono essere restituiti integri, non usati e con confezione originale
        • Le spese di restituzione sono a carico del cliente
        • Il rimborso verrà effettuato entro 14 giorni dalla ricezione del reso
        • Il rimborso avverrà con lo stesso metodo di pagamento utilizzato
        • Articoli personalizzati o su misura non sono rimborsabili
        • Per avviare un reso, contatta l'assistenza clienti`
    },
    {
      icon: AlertTriangle,
      title: 'Garanzia e Responsabilità',
      content: `Limitazioni di responsabilità e garanzie:
        • Tutti i prodotti godono della garanzia legale di 24 mesi
        • La garanzia copre difetti di conformità, non danni accidentali
        • Le immagini dei prodotti sono indicative e possono variare leggermente
        • Non garantiamo che il sito sia sempre disponibile o privo di errori
        • La nostra responsabilità è limitata al valore dell'ordine
        • Non siamo responsabili per danni indiretti o consequenziali`
    },
    {
      icon: Scale,
      title: 'Proprietà Intellettuale',
      content: `Diritti di proprietà intellettuale:
        • Tutti i contenuti del sito (testi, immagini, logo) sono di proprietà di QANTRI
        • È vietata la riproduzione senza autorizzazione scritta
        • I marchi dei prodotti appartengono ai rispettivi proprietari
        • L'uso non autorizzato può comportare azioni legali
        • I contenuti generati dagli utenti rimangono di loro proprietà`
    },
    {
      icon: HelpCircle,
      title: 'Programmi Speciali',
      content: `Condizioni per Affiliati e Venditori:
        
        Programma Affiliati:
        • Commissione del 10% sulle vendite generate tramite il tuo codice
        • I clienti ricevono uno sconto del 10% usando il codice affiliato
        • Le commissioni vengono pagate mensilmente via PayPal
        • Ci riserviamo il diritto di sospendere account per attività fraudolente
        
        Programma Venditori:
        • Abbonamento mensile richiesto per vendere su QANTRI
        • Commissione del 5% su ogni vendita
        • I venditori sono responsabili della qualità dei loro prodotti
        • QANTRI si riserva il diritto di rimuovere prodotti non conformi`
    }
  ];

  return (
    <div className="min-h-screen py-12 md:py-16" data-testid="terms-conditions-page">
      <div className="max-w-4xl mx-auto px-6 md:px-12">
        {/* Header */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-[#064E3B]/10 mb-6">
            <FileText className="w-8 h-8 text-[#064E3B]" />
          </div>
          <h1 className="text-3xl md:text-4xl font-bold font-serif mb-4">
            Termini e Condizioni
          </h1>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            Benvenuto su QANTRI. Utilizzando il nostro sito e i nostri servizi, 
            accetti i seguenti termini e condizioni. Ti invitiamo a leggerli attentamente.
          </p>
          <p className="text-sm text-muted-foreground mt-4">
            Ultimo aggiornamento: Dicembre 2025
          </p>
        </div>

        {/* Introduction */}
        <div className="bg-[#064E3B]/5 rounded-2xl p-6 md:p-8 mb-8">
          <h2 className="text-xl font-bold font-serif mb-4">Informazioni Generali</h2>
          <p className="text-muted-foreground leading-relaxed mb-4">
            QANTRI è un marketplace online che offre prodotti selezionati di alta qualità. 
            Questi Termini e Condizioni regolano l'uso del sito web qantri.store e tutti 
            i servizi correlati.
          </p>
          <p className="text-muted-foreground leading-relaxed">
            Effettuando un acquisto o registrandoti sul nostro sito, dichiari di aver letto, 
            compreso e accettato integralmente questi termini. Se non accetti questi termini, 
            ti preghiamo di non utilizzare il nostro sito.
          </p>
        </div>

        {/* Sections */}
        <div className="space-y-6">
          {sections.map((section, index) => (
            <div 
              key={index}
              className="bg-white rounded-2xl border border-border p-6 md:p-8 hover:shadow-md transition-shadow"
            >
              <div className="flex items-start gap-4">
                <div className="shrink-0 w-12 h-12 rounded-xl bg-[#064E3B]/10 flex items-center justify-center">
                  <section.icon className="w-6 h-6 text-[#064E3B]" />
                </div>
                <div className="flex-1">
                  <h3 className="text-lg font-bold font-serif mb-3">{section.title}</h3>
                  <div className="text-muted-foreground leading-relaxed whitespace-pre-line">
                    {section.content}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Modifications */}
        <div className="bg-amber-50 border border-amber-200 rounded-2xl p-6 md:p-8 mt-8">
          <h3 className="text-lg font-bold font-serif mb-3 text-amber-800">Modifiche ai Termini</h3>
          <p className="text-amber-700 leading-relaxed">
            QANTRI si riserva il diritto di modificare questi Termini e Condizioni in qualsiasi momento. 
            Le modifiche saranno effettive dalla data di pubblicazione sul sito. 
            L'uso continuato del sito dopo le modifiche costituisce accettazione dei nuovi termini.
            Ti consigliamo di consultare periodicamente questa pagina.
          </p>
        </div>

        {/* Applicable Law */}
        <div className="bg-white rounded-2xl border border-border p-6 md:p-8 mt-8">
          <h3 className="text-lg font-bold font-serif mb-3">Legge Applicabile e Foro Competente</h3>
          <p className="text-muted-foreground leading-relaxed mb-4">
            Questi Termini e Condizioni sono regolati dalla legge italiana. Per qualsiasi controversia 
            relativa all'interpretazione, validità o esecuzione di questi termini, sarà competente 
            il Foro del consumatore, come previsto dal Codice del Consumo (D.Lgs. 206/2005).
          </p>
          <p className="text-muted-foreground leading-relaxed">
            Per le controversie B2B, sarà competente il Foro di Milano.
          </p>
        </div>

        {/* Contact */}
        <div className="bg-white rounded-2xl border border-border p-6 md:p-8 mt-8">
          <h3 className="text-lg font-bold font-serif mb-3">Contatti</h3>
          <p className="text-muted-foreground leading-relaxed mb-4">
            Per qualsiasi domanda riguardante questi Termini e Condizioni, puoi contattarci:
          </p>
          <ul className="space-y-2 text-muted-foreground">
            <li className="flex items-center gap-2">
              <span className="font-medium">Email:</span>
              <span>info@qantri.store</span>
            </li>
            <li className="flex items-center gap-2">
              <span className="font-medium">Supporto:</span>
              <a href="/support" className="text-[#064E3B] hover:underline">/support</a>
            </li>
          </ul>
        </div>

        {/* Footer Note */}
        <p className="text-center text-sm text-muted-foreground mt-8">
          Grazie per aver scelto QANTRI. Il tuo acquisto consapevole ci aiuta a migliorare ogni giorno.
        </p>
      </div>
    </div>
  );
};

export default TermsConditionsPage;
